import { IonButton, IonButtons, IonCard, IonCardContent, IonCheckbox, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSelect, IonSelectOption, IonSkeletonText, IonTitle, IonToolbar, RefresherEventDetail, useIonAlert, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { at, checkmarkCircleOutline, chevronBackOutline, hourglassOutline, removeCircleOutline, trashOutline } from 'ionicons/icons';
import { alertController } from '@ionic/core';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAppContext } from '../AppProvider';

interface RouteParams {
    token: string;
}

const ContactEdit: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [Contact, setContact] = useState<any>({});
    const [nameEdit, setNameEdit] = useState<boolean>(false);
    const [emailEdit, setEmailEdit] = useState<boolean>(false);
    const [phoneEdit, setPhoneEdit] = useState<boolean>(false);
    const [contactPhone, setContactPhone] = useState<string>('');

    const { authKey, authenticateMember, setShowLoader, settings, countries, getCountries, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();

    const [showAlert] = useIonAlert();
    const [showToast] = useIonToast();
    const phoneInputRef = useRef<any>();

    const { token } = useParams<RouteParams>();
    const router = useIonRouter();

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const authenticated = await authenticateMember();   
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            else {
                await getContact(token, authenticated.mt);
                await getCountries();
                setLoading(false)
                setTimeout(() => setShowLoader(false), 2000);
            }
        };
        authenticate();
    }); 


    // 
    // Handle the event when the action sheet visibility changes
    //
    const handleAlertVisibilityChange = (event: CustomEvent) => {
        let elements = document.getElementsByTagName('ion-router-outlet');
        for (const element of elements) {
            element.removeAttribute('aria-hidden');
        }
    };

    const toggleNameForm = () => setNameEdit(!nameEdit);
    const toggleEmailForm = () => setEmailEdit(!emailEdit);
    const togglePhoneForm = () => setPhoneEdit(!phoneEdit);


    const getContact = async (ct: string, mt: string) => {
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('ct', ct);
            const response = await fetch('https://api.besolowise.com/contacts/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json();
                
                if(typeof obj.contactID == 'number') {
                    setContact(obj); 
                } else {
                    showToast({
                        message: 'Data Error',
                        duration: 2000,
                        color: 'danger',
                        position: 'middle'
                    });
                }
            } else {
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error + '. Refresh this page to try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }       
    };


    const updateContact = async (e: any) => {
        e.preventDefault();
        let formName = '';

        if(e.target.id === 'contactAlwaysUse') {
            let elemVal = e.detail.checked;
            elemVal = elemVal ? '1' : '0'
            formName = 'selectedForm';
            var formData = new FormData(); 
            formData.append('formName', formName);
            formData.append('updateValue', elemVal);
            formData.append('token', token);
        } else {
            const form = e.target; 
            formName = form.name;
            var btn: any = document.getElementById(formName + 'Submit');
            btn.innerHTML = 'Saving...';
            btn.setAttribute('disabled', '');
            var formData = new FormData(form);
            formData.append('formName', formName);
            formData.append('token', token);
        }
        formData.append('mt', authKey.mt);

        try {
            const response = await fetch('https://api.besolowise.com/contacts/update/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    await getContact(token, authKey.mt);
                    if(typeof btn !== 'undefined') btn.innerHTML = 'Save';
                    if(typeof btn !== 'undefined') btn.removeAttribute('disabled');
                    if(typeof btn !== 'undefined') document.getElementById(formName + 'Cancel')?.click();
                    showToast({
                        message: 'Saved ',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    if(typeof btn !== 'undefined') btn.innerHTML = 'Save';
                    if(typeof btn !== 'undefined') btn.removeAttribute('disabled');
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 3000,
                        color: 'danger',
                    });
                }
            } else {
                if(typeof btn !== 'undefined') {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                }
                showToast({
                    message: 'Response Error',
                    duration: 3000,
                    color: 'danger',
                });
            }            
        } catch(error) {
            console.log(typeof btn);
            if(typeof btn !== 'undefined') btn.innerHTML = 'Save';
            if(typeof btn !== 'undefined') btn.removeAttribute('disabled');
            showToast({
                message: 'Connection Error: ' + error,
                duration: 3000,
                color: 'danger',
            });
        } 
    };

    const confirmContactChange = (e: any) => {
        const showAlert = async () => {
            const alert = await alertController.create({
                header: 'Confirm!',
                message: 'Updating the email address of this Emergency Contact will reset the status to "Pending".',
                buttons: [
                    { text: 'Cancel', 
                    role: 'cancel',
                    cssClass: 'alert-button-cancel'
                    },
                    {
                        text: 'Update',
                        role: 'confirm',
                        cssClass: 'alert-button-confirm',
                        handler: () => { 
                            updateContact(e); 
                        },
                    }
                ],  
            });

            // Add an event listener for ionAlertWillPresent
            alert.addEventListener('ionAlertWillPresent', () => {
                handleAlertVisibilityChange(e); // Trigger your custom function here
            });
            
            await alert.present();
        };

        showAlert();
        e.preventDefault();        
    };

    const statusChip = (s: string) => {
        switch(s) {
            case '0': return <IonChip slot='end' color={'medium'}><IonIcon icon={hourglassOutline}></IonIcon><IonLabel>Pending</IonLabel></IonChip>
            case '1': return <IonChip slot='end' color={'medium'}><IonIcon icon={hourglassOutline}></IonIcon><IonLabel>Pending</IonLabel></IonChip>
            case '2': return <IonChip slot='end' color={'success'}><IonIcon icon={checkmarkCircleOutline}></IonIcon><IonLabel>Confirmed</IonLabel></IonChip>
            case '3': return <IonChip slot='end' color={'danger'}><IonLabel>Error</IonLabel></IonChip>
            default:  return <IonChip slot='end' color={'light'}><IonLabel>Unknown</IonLabel></IonChip>
        }
    };

    const deleteContact = () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to REMOVE this Emergency Contact?',
            buttons: [
                { text: 'Cancel', 
                  role: 'cancel',
                  cssClass: 'alert-button-cancel'
                },
                {
                    text: 'Remove',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        try {
                            const formData = new FormData();
                            formData.append('mt', authKey.mt);
                            formData.append('token', token);
                            const apiURI = 'https://api.besolowise.com/contacts/delete/';
                            const response = await fetch(apiURI, {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });
                            if(response.ok) {
                                const obj = await response.json(); 
                                if(obj.success) {
                                    router.push('/account/contacts', 'back');
                                } else {
                                    showToast({
                                        message: 'Data error.',
                                        duration: 2000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response error.',
                                    duration: 2000,
                                    color: 'danger',
                                });
                            }
                        } catch(error) {
                            showToast({
                                message: 'Connection Error: ' + error,
                                duration: 2000,
                                color: 'danger',
                            });
                        }  
                    }
                }
            ]
        })
    };

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setTimeout(() => {
          getContact(token, authKey.mt);
          event.detail.complete();
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/contacts'>Contacts</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id='ContactContent' fullscreen>
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='8'>
                            <h1><IonIcon className='m-hide' color={'secondary'} icon={at}></IonIcon> {Contact.contactFirstName} {Contact.contactLastName}<br /><span>Emergency Contact</span></h1>                            
                        </IonCol>
                        <IonCol className='top-action-button' size='12' sizeSm='4'>
                            <p className='ion-margin-bottom'>{statusChip(Contact.contactStatus)}</p>
                        </IonCol>
                    </IonRow>
                </IonGrid>
           
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleNameForm}><b>Name</b> <em className='required'>Required</em></IonLabel>
                        { nameEdit 
                            ? (<form name='nameForm' onSubmit={updateContact}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='contactFirstName' placeholder='First name' type='text' value={Contact.contactFirstName}></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='contactLastName' placeholder='Last name' type='text' value={Contact.contactLastName}></IonInput>
                                            </IonCol>                                   
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='nameFormCancel' onClick={toggleNameForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='nameFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<>
                                {loading 
                                    ? (<p><IonSkeletonText animated={true} style={{ width: '40%' }}></IonSkeletonText></p>)
                                    : (<p onClick={toggleNameForm}>{Contact.contactFirstName} {Contact.contactLastName}</p>)
                                }
                                </>)
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleEmailForm}><b>Email</b> <em className='required'>Required</em></IonLabel>
                        { emailEdit  
                            ? (<form name='emailForm' onSubmit={confirmContactChange}> 
                                    <IonInput fill='outline' name='contactEmail' type='email' value={Contact.contactEmail}></IonInput>
                                    <IonButton className='ion-margin-top' color={'medium'} id='emailFormCancel' onClick={toggleEmailForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='emailFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<>
                                {loading 
                                    ? (<p><IonSkeletonText animated={true} style={{ width: '60%' }}></IonSkeletonText></p>)
                                    : (<p onClick={toggleEmailForm}>{Contact.contactEmail}</p>)
                                }
                                </>) 
                        }
                    </IonCardContent>
                </IonCard> 

                <IonCard>
                    <IonCardContent>                        
                        <form name='selectedForm'>
                            <IonCheckbox checked={Contact.contactAlwaysUse === '1'} className='ion-margin-top' color={'secondary'} labelPlacement="end" id='contactAlwaysUse' name='contactAlwaysUse'
                            onIonChange={updateContact}
                            >Automatically add to my Timers.</IonCheckbox> 
                        </form> 
                    </IonCardContent>
                </IonCard>

                <div className='ion-text-center'>
                    <IonButton className='ion-margin delete-button-outline' color={'remove'} fill="outline" onClick={deleteContact}><IonIcon icon={trashOutline} slot='start'></IonIcon> Remove Contact</IonButton>
                </div>

            </IonContent>
        </IonPage>
    );
};

export default ContactEdit;
